import client from './client';

export const listCumulativeRevenue = (params) =>
  client.get('/cumulative-revenue', { params }).then((r) => r.data);

export const customerRevenueSeries = (params) =>
  client.get('/cumulative-revenue/customer', { params }).then((r) => r.data);
